export class Product {
  id: number;
  name: string;
  description: string;
  quantity: number;
}
